import React, { useState } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './CaDetailedCourses.css';

const CaDetailedCourses = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabsData = [
    {
      label: 'Noorani Qaida Course',
      title: 'Learn Noorani Qaida Online with Expert Quran Tutors',
      paragraph1: 'Noorani Qaida is the first and most important step for anyone who wants to learn Quran recitation correctly. Our online Noorani Qaida course is specially designed for kids, beginners, and adults who want to build a strong foundation in Quran reading with proper pronunciation and Tajweed rules. We provide one-on-one live classes with experienced male and female Quran tutors who teach students in a simple, friendly, and interactive way.',
      paragraph2: 'In this course, students learn Arabic alphabets, correct pronunciation (Makharij), joining letters, word formation, and basic Tajweed rules. Our tutors focus on helping students read the Quran fluently and confidently from the very beginning.'
    },
    {
      label: 'Quran Tajweed Classes',
      title: 'Learn Quran with Tajweed from Qualified Tutors',
      paragraph1: 'Our Quran Tajweed classes online are specially designed for students who want to recite the Holy Quran beautifully and correctly according to Tajweed rules. Whether you are a child, teenager, or adult, our qualified male and female Quran teachers provide step-by-step guidance to help you improve your recitation.',
      paragraph2: 'Tajweed is essential for proper Quran recitation because it teaches the correct pronunciation, articulation points, and rhythm of Quranic words. In our online Quran Tajweed course, students receive personalized attention and regular practice sessions to perfect their recitation skills.'
    },
    {
      label: 'Quran Reading Classes Online',
      title: 'Online Quran Reading Course for Kids and Adults',
      paragraph1: 'Our Quran reading classes online are ideal for students who want to improve their Quran recitation skills from basic to advanced levels. We offer professional Quran learning programs for both kids and adults with highly experienced male and female Quran tutors.',
      paragraph2: 'These classes focus on improving fluency, pronunciation, and confidence in reading the Holy Quran. Whether you are a beginner or someone looking to strengthen your Quran reading abilities, our tutors create customized lessons according to your learning level.'
    },
    {
      label: 'Quran Memorization Classes Online',
      title: 'Learn Quran Hifz Online with Expert Quran Tutors',
      paragraph1: 'Our Quran Memorization classes online are specially designed for kids and adults who want to memorize the Holy Quran with proper guidance, Tajweed, and daily revision. We provide one-on-one online Hifz classes with experienced male and female Quran tutors who help students memorize the Quran step by step in an easy, structured, and effective way.',
      paragraph2: 'This course focuses on strong memorization techniques, correct pronunciation, fluency, and regular revision to help students retain what they learn. Whether you want to memorize selected Surahs, specific Juz, or complete Hifz-ul-Quran, our tutors create personalized lesson plans according to each student’s learning ability and pace.'
    },
    {
      label: 'Quran Translation Classes Online',
      title: 'Learn Quran Translation and Understand the Meaning of the Holy Quran',
      paragraph1: 'Our Quran Translation Classes Online are specially designed for students who want to understand the meaning of the Holy Quran in a simple and effective way. This course helps learners translate Quranic verses accurately so they can connect deeply with the message of Allah and apply Islamic teachings in daily life.',
      paragraph2: 'We offer one-on-one online classes with experienced male and female Quran tutors who guide students step by step in understanding Quranic vocabulary, word-by-word translation, and the context of verses. Whether you are a beginner or already have basic Quran knowledge, this course is structured to improve your understanding gradually and clearly.'
    }
  ];

  return (
    <section className="Ca-detailed-courses" id="detailed-courses">
      <div className="Ca-detailed-courses__container">
        {/* Main Section Title */}
        <h2 className="Ca-detailed-courses__title">
          Our Detailed Quran Courses
        </h2>

        {/* Subtitle Description */}
        <p className="Ca-detailed-courses__subtitle">
          Our Online Quran Courses Are Designed For Kids And Adults Who Want To Learn The Holy Quran With Proper Guidance From Experienced Male And Female Tutors. From Noorani Qaida And Quran Reading To Tajweed And Quran Translation, We Provide Step-By-Step Online Classes With Flexible Timings, Personalized Attention, And An Easy Learning Environment To Help Students Improve Their Quranic Knowledge And Recitation Skills From The Comfort Of Their Homes.
        </p>

        {/* Tabs Control Rows */}
        <div className="Ca-detailed-courses__tabs-container">
          {/* Row 1: 3 Tabs */}
          <div className="Ca-detailed-courses__tabs-row">
            {tabsData.slice(0, 3).map((tab, index) => (
              <button
                key={index}
                className={`Ca-detailed-courses__tab-btn ${activeTab === index ? 'Ca-detailed-courses__tab-btn--active' : ''}`}
                onClick={() => setActiveTab(index)}
              >
                <span>{tab.label}</span>
                {activeTab === index && (
                  <FiArrowRight className="Ca-detailed-courses__tab-arrow" />
                )}
              </button>
            ))}
          </div>

          {/* Row 2: 2 Tabs */}
          <div className="Ca-detailed-courses__tabs-row">
            {tabsData.slice(3, 5).map((tab, idx) => {
              const index = idx + 3;
              return (
                <button
                  key={index}
                  className={`Ca-detailed-courses__tab-btn ${activeTab === index ? 'Ca-detailed-courses__tab-btn--active' : ''}`}
                  onClick={() => setActiveTab(index)}
                >
                  <span>{tab.label}</span>
                  {activeTab === index && (
                    <FiArrowRight className="Ca-detailed-courses__tab-arrow" />
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content Box */}
        <div className="Ca-detailed-courses__content-box">
          <h3 className="Ca-detailed-courses__content-title">
            {tabsData[activeTab].title}
          </h3>
          <p className="Ca-detailed-courses__content-paragraph">
            {tabsData[activeTab].paragraph1}
          </p>
          <p className="Ca-detailed-courses__content-paragraph">
            {tabsData[activeTab].paragraph2}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CaDetailedCourses;
